import WorldPage from './WorldPage';

export default WorldPage;